module.exports = __webpack_public_path__ + "static/media/KEDCO.203a47b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/KEDCO.png
// module id = 376
// module chunks = 25